import Label from './Label';
export { Label };
export default Label;
